import React, { Component } from 'react';
const smallLoader = require('../small_loader.gif');

class SmallLoader extends Component {
    render() {
        return (
            <div id='small-loader' className="d-inline-block ml-2 align-middle">
                <img className="small-loader" src={smallLoader} alt='Loading...' />
            </div>
        )
    }
}

export default SmallLoader;